<script>
import Popin from "@/components/molecules/popin";
import Icon from "@/components/atoms/icon";
import Badge from "@/components/atoms/badge";
import Button from "@/components/atoms/button";
import Titre from "@/components/atoms/titre";

export default {
  name: "TransformerPoints",
  components: { Popin, Icon, Badge, Button, Titre },
  props: {
    deleted: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ["confirmDelete"],
  methods: {
    show() {
      this.$refs.popin.show();
    },
    hide() {
      const self = this;
      setTimeout(function () {
        self.$refs.popin.hide();
      }, 5000);
    }
  }
};
</script>

<template>
  <Popin
    ref="popin"
    aria-label="Suppression carte réussie"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
  >
    <div class="u-text-center u-pb-sm">
      <template v-if="deleted">
        <Badge
          :variant="'success'"
          circle
          size="xlg"
        >
          <Icon
            name="check"
            variant="white"
          />
        </Badge>
        <p class="u-mt-sm u-font-15 u-font-16@sm">
          Suppression carte réussie.
        </p>
      </template>

      <template v-else>
        <div class="u-text-center">
          <Badge
            variant="white"
            circle
            size="xlg"
          >
            <Icon
              name="alert-circle"
              variant="primary"
              size="lg"
            />
          </Badge>
          <Titre
            tag="h1"
            variant="primary"
            size="md"
            class="u-mt-xs u-mb-md"
          >
            Supprimer votre carte
          </Titre>
          <p class="u-font-14 u-mb-md u-pl-lg u-pr-lg">
            Etes-vous sûr de vouloir supprimer cette carte de votre compte client?
          </p>

          <Button
            variant="primary"
            radius="full"
            size="md"
            @click="$emit('confirmDelete')"
          >
            Oui je supprime
          </Button>
        </div>
      </template>
    </div>
  </Popin>
</template>

<style lang="scss" scoped>
</style>
